import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
// import * as Sentry from '@sentry/react';
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';
import { Toaster } from 'sonner';

import App from './App/App.tsx';
import { ThemeProvider } from './contexts/ThemeContext.tsx';

// Sentry.init({
//     dsn: 'https://58fe9d33ace4c4e283b16fc8d5c9eb4a@o4509141093253120.ingest.de.sentry.io/4509909686091856',
//     // Setting this option to true will send default PII data to Sentry.
//     // For example, automatic IP address collection on events
//     sendDefaultPii: true,
//     integrations: [
//         Sentry.browserTracingIntegration(),
//         Sentry.replayIntegration(),
//     ],
//     // Tracing
//     tracesSampleRate: 1.0,
//     tracePropagationTargets: [
//         'localhost',
//         /^https:\/\/chanco-api\.codex\.com\.np\/api/, // Example: Match API routes
//         /^https:\/\/chanco-admin\.codex\.com\.np/, // Match all routes on your domain
//     ],
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
// });

const queryClient = new QueryClient();

const webappRootId = 'root';
const webappRootElement = document.getElementById(webappRootId);
if (webappRootElement === undefined || webappRootElement === null) {
    // eslint-disable-next-line no-console
    console.error(`Could not find html element with id '${webappRootId}'`);
} else {
    ReactDOM.createRoot(webappRootElement).render(
        // <Sentry.ErrorBoundary fallback={<p>An error has occured.</p>}>
        <React.StrictMode>
            <ThemeProvider>
                <QueryClientProvider client={queryClient}>
                    <App />
                    <Toaster />
                </QueryClientProvider>
            </ThemeProvider>
        </React.StrictMode>
        ,
        // </Sentry.ErrorBoundary>,
    );
}
